import {
  getCriticalIllnessChartData,
  getCriticalIllnessChartLayout,
} from "./akaAdviceChartCriticalIllnessConfig";

import { BarChart } from "Components/Chart/BarChart";
import { ChartDivId } from "Components/Chart/chartInterface";
import { useAkaAdviceBaseAmountSelector } from "Store/akaAdvice/akaAdviceSelectors";
import { useWindowSize } from "Utils/screenSizeUtils";
import { FormikProps } from "formik";
import React from "react";
import { AkaAdvicePriceFormValues } from "../../interfaces";

interface Props {
  formProps: FormikProps<AkaAdvicePriceFormValues>;
  income: number;
}

export const AkaAdviceChartCriticalIllness = ({
  formProps,
  income,
}: Props): React.ReactElement => {
  const windowSize = useWindowSize();
  const baseAmount = useAkaAdviceBaseAmountSelector();

  const chartData = getCriticalIllnessChartData(income, formProps, baseAmount);

  return (
    <div className={ChartDivId.CRITICAL_ILLNESS}>
      <BarChart
        divId={ChartDivId.CRITICAL_ILLNESS}
        data={chartData}
        layout={getCriticalIllnessChartLayout(windowSize)}
        isStackedBarChart
      />
    </div>
  );
};
